/** `ignoreNullValue` is off on the form data, so a `null` file reaches this check and is rejected. */
function isLogoFileSelected(value: File | null): boolean {
	return value !== null;
}

export default isLogoFileSelected;
